export default __webpack_public_path__ + "static/media/projectLogo.928a532e.png";